"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.iconStyles = exports.StyledTrigger = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _popover = _interopRequireDefault(require("@paprika/popover"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _helpers = require("@paprika/stylers/lib/helpers");

var StyledTrigger = (0, _styledComponents["default"])(_popover["default"].Trigger).withConfig({
  displayName: "Helpstyles__StyledTrigger",
  componentId: "wab60d-0"
})(["height:1em;width:1em;"]);
exports.StyledTrigger = StyledTrigger;
var iconStyles = (0, _styledComponents.css)(["color:", ";"], _tokens["default"].textColor.icon);
exports.iconStyles = iconStyles;
var helpStyles = (0, _styledComponents.css)(["height:1em;position:absolute;right:-", "px;top:1px;"], (0, _helpers.toInt)(_tokens["default"].spaceSm) * 5);
var _default = helpStyles;
exports["default"] = _default;
//# sourceMappingURL=Help.styles.js.map